export default {
    state: {
		showData:{
            adjustDay:30,
            day:180,
            id:883,
            isCanCommitQuestionnaire:2,
            name:"深圳",
            supportEventOfflineSend:-1
        },
        showQuesstion:2,
        showToast:'',
        leftMenu:[],
        platformList:[],
        userCenterMenuList:[],
        mediaLevelList:[],
        mediaLevelTips:{},
        memberRechargeIcon:[],
        companyTypes:[],
        configInfo:{}
    },

    mutations: {
        configInfo(state,data){
            state.configInfo = data;
        },
		setShowData(state,data){
            state.showData = data;
            state.showQuesstion = data.isCanCommitQuestionnaire;
        },
        changeShowData(state,data){
            state.showQuesstion = data;
        },
        setToastData(state,data){
            state.showToast = data.text;
        },
        setLeftMenu(state,leftMenu){
            state.leftMenu = leftMenu;
        },
        setplatformList(state,leftMenu){
            state.platformList = leftMenu;
        },
        setuserCenterMenuList(state,userCenterMenuList){
            state.userCenterMenuList = userCenterMenuList;
        },
        setmediaLevelList(state,mediaLevelList){
            // let list = [];
            // for(let item in mediaLevelList){
            //     let obj1 = {
            //         label:item,
            //         value:item,
            //         children:[]
            //     }
            //     for(let items of mediaLevelList[item]){
            //         let obj2 = {
            //             label:items,
            //             value:items,
            //         }
            //         obj1.children.push(obj2)
            //     }
            //     list.push(obj1);
            // }
            // state.mediaLevelList = list;
            state.mediaLevelList = mediaLevelList;
        },
        setmediaLevelTips(state,mediaLevelTips){
            state.mediaLevelTips = mediaLevelTips;
        },
        setmemberRechargeIcon(state,memberRechargeIcon){
            state.memberRechargeIcon = memberRechargeIcon;
        },
        setcompanyTypes(state,companyTypes){
            state.companyTypes = companyTypes;
        },
    },

    actions: {
        getConfigInfo({commit},parms){
            commit('configInfo',parms)
        },
        getShowData({commit},parms){
            commit('setShowData',parms)
        },
        changeToast({commit},parms){
            commit('setToastData',parms)
        },
        getMenuList({commit},parms){
            commit('setLeftMenu',parms)
        },
        getplatformList({commit},parms){
            commit('setplatformList',parms)
        },
        getuserCenterMenuList({commit},parms){
            commit('setuserCenterMenuList',parms)
        },
        getmediaLevelList({commit},parms){
            commit('setmediaLevelList',parms)
        },
        getmediaLevelTips({commit},parms){
            commit('setmediaLevelTips',parms)
        },
        getmemberRechargeIcon({commit},parms){
            commit('setmemberRechargeIcon',parms)
        },
        getcompanyTypes({commit},parms){
            commit('setcompanyTypes',parms)
        },
    },
    namespaced: true
}


// WEBPACK FOOTER //
// ./src/store/modules/show.js